module.exports = __webpack_public_path__ + "static/media/3 Train-AP_Z2.81eeddc9.png";